var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28249",
    "data-name": "\\uC0AC\\uAC01\\uD615 28249",
    width: 12.833,
    height: 22.119,
    fill: "#343a40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21863",
    "data-name": "\\uADF8\\uB8F9 21863",
    transform: "translate(-349 -2893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28250",
    "data-name": "\\uC0AC\\uAC01\\uD615 28250",
    width: 24,
    height: 24,
    transform: "translate(349 2893)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21862",
    "data-name": "\\uADF8\\uB8F9 21862",
    transform: "translate(354.584 2893.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21861",
    "data-name": "\\uADF8\\uB8F9 21861",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10314",
    "data-name": "\\uD328\\uC2A4 10314",
    d: "M11.8,13.233H1.031a1.031,1.031,0,0,1-.952-.657A1.087,1.087,0,0,1,.3,11.418L2.154,9.509V3.727L.3,1.815A1.087,1.087,0,0,1,.079.656,1.031,1.031,0,0,1,1.031,0H11.8a1.032,1.032,0,0,1,.953.656,1.089,1.089,0,0,1-.223,1.159L10.679,3.728V9.51l1.852,1.908a1.09,1.09,0,0,1,.224,1.159,1.033,1.033,0,0,1-.953.657m-8.28-2.127H9.311l-.392-.4a1.082,1.082,0,0,1-.3-.752V3.288a1.082,1.082,0,0,1,.3-.752l.4-.41H3.52l.4.408a1.08,1.08,0,0,1,.3.752V9.949a1.081,1.081,0,0,1-.3.752Z",
    transform: "translate(0 0)",
    fill: "#343a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10315",
    "data-name": "\\uD328\\uC2A4 10315",
    d: "M13.105,37.043a1.048,1.048,0,0,1-1.031-1.063V27.095a1.032,1.032,0,1,1,2.062,0V35.98a1.048,1.048,0,0,1-1.031,1.063",
    transform: "translate(-6.923 -14.925)",
    fill: "#343a40"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon5);
export default __webpack_public_path__ + "static/media/DetailIcon5.86296714dd903b673895b1990e3260fd.svg";
export { ForwardRef as ReactComponent };